<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Edit Profile</li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Edit Profile</h1>
        <hr>

        <div class="row" v-if="userData" style="padding : 0 1%">
            <div class="col-md-3 col-sm-12 border border-secondary rounded text-center" style="background-color:#f5f5f5">
                <img src="@/assets/img/user/noPicUser.png" class="img-fluid" style="padding:5%"/>
                <h5>{{userData.fullname}}</h5>
                User Type : <span class="h5">{{userData.type}}</span>
            </div>
            <div class="col-md-9  col-sm-12 " style="padding-left:3%">
                <panel class="border border-secondary" :noButton='true' style="margin-bottom : 0;">
                    <template slot="header">
                        <h4 class="panel-title">Profile Account</h4>
                    </template>

                    <div class="form-group">
                        <label>Fullname</label>
                        <input type="text" placeholder="Fullname" class="form-control" v-model='updateData.name'/>
                    </div>
                    <hr>
                    <h5>Change Password Option</h5>
                    <div class="form-group">
                        <label>Old Password</label>
                        <input type="password" placeholder="Old Password" class="form-control" v-model='updateData.old_password'/>
                    </div>
                    <div class="form-group">
                        <label>New Password</label>
                        <input type="password" placeholder="New Password" class="form-control" v-model='updateData.new_password'/>
                    </div>
                    <div class="form-group">
                        <label>New Password Confirmation</label>
                        <input type="password" placeholder="New Password Confirmation" class="form-control" v-model='updateData.confirm_password'/>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary w-25 p-5" v-on:click="updateProfile()">Edit Profile</button>
                    </div>
                    
                </panel>
            </div>
        </div>
    </div>
</template>

<script>
import PageOptions from '@/Options/PageOptions.js';

    
export default {
    metaInfo: {
      title: 'Edit Profile',
      titleTemplate: '%s - QTrust',
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    },
    data(){
        return{
            pageOptions : PageOptions,
            currentComponent : '',
            userData : null,
            updateData : {
                name : '',
                old_password : null,
                new_password : null,
                confirm_password : null
            }
        }
    },
    created(){
        this.pageOptions.pageEmpty = false;
        this.currentComponent = this.$store.state.company + "Dashboard";
    },
    beforeRouteLeave (to, from, next) {
		PageOptions.pageEmpty = true;
		next();
    },
    mounted(){
        this.loadUserData();
    },
    methods:{
        loadUserData(){
            this.$http.get('/api/auth')
            .then((resp)=>{
                         
                this.userData = resp.data.data;
                this.updateData.name = this.userData.fullname;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        updateProfile(){
            if(this.updateData.new_password != this.updateData.confirm_password){
                return;
            }

            this.$http.put('/api/auth/profile' , this.updateData)
            .then((resp)=>{
                         
                alert("Successfully Updated User Profile");
                this.$store.dispatch('setUser', resp.data.data);
            })
            .catch((err)=>{
                console.log(err);
                
            })
        }
    }
}
</script>